export const ctodTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_authorised' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.project' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },
  { header: 'generateReport.dataToResult.report.general.id_amostra' },

  { header: 'generateReport.dataToResult.report.test.ctod.maquina_de_ensaio' },
  { header: 'generateReport.dataToResult.report.test.ctod.clip_gage' },
  { header: 'generateReport.dataToResult.report.test.ctod.termometro' },
  { header: 'generateReport.dataToResult.report.test.ctod.cronometro' },
  { header: 'generateReport.dataToResult.report.test.ctod.paquimetro' },
  { header: 'generateReport.dataToResult.report.test.ctod.maquina_de_medicao' },

  { header: 'generateReport.dataToResult.report.test.ctod.valor_rt' },
  { header: 'generateReport.dataToResult.report.test.ctod.orientacao_cp' },
  { header: 'generateReport.dataToResult.report.test.ctod.norma_ctod' },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.abertura_clip_gauge_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.abertura_clip_gauge_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.abertura_clip_gauge_cp3',
  },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp3',
  },

  { header: 'generateReport.dataToResult.report.test.ctod.comprimento_cp1' },
  { header: 'generateReport.dataToResult.report.test.ctod.comprimento_cp2' },
  { header: 'generateReport.dataToResult.report.test.ctod.comprimento_cp3' },

  {
    header: 'generateReport.dataToResult.report.test.ctod.comprimento_astm_cp1',
  },
  {
    header: 'generateReport.dataToResult.report.test.ctod.comprimento_astm_cp2',
  },
  {
    header: 'generateReport.dataToResult.report.test.ctod.comprimento_astm_cp3',
  },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_pre_trinca_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_pre_trinca_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_pre_trinca_cp3',
  },

  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp1' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp1_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp1_max' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp2' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp2_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp2_max' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp3' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp3_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.espessura_cp3_max' },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.espessura_knife_edge_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.espessura_knife_edge_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.espessura_knife_edge_cp3',
  },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.forca_maxima_aplicada_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.forca_maxima_aplicada_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.forca_maxima_aplicada_cp3',
  },

  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp1' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp1_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp1_max' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp2' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp2_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp2_max' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp3' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp3_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.largura_cp3_max' },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.limite_de_escoamento_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.limite_de_escoamento_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.limite_de_escoamento_cp3',
  },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.limite_de_resistencia_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.limite_de_resistencia_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.limite_de_resistencia_cp3',
  },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.forca_max_pre_trinca_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.forca_max_pre_trinca_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.forca_max_pre_trinca_cp3',
  },

  { header: 'generateReport.dataToResult.report.test.ctod.span_cp1_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.span_cp1_max' },
  { header: 'generateReport.dataToResult.report.test.ctod.span_cp2_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.span_cp2_max' },
  { header: 'generateReport.dataToResult.report.test.ctod.span_cp3_min' },
  { header: 'generateReport.dataToResult.report.test.ctod.span_cp3_max' },

  { header: 'generateReport.dataToResult.report.test.ctod.razao_dk_dt_cp1' },
  { header: 'generateReport.dataToResult.report.test.ctod.razao_dk_dt_cp2' },
  { header: 'generateReport.dataToResult.report.test.ctod.razao_dk_dt_cp3' },

  { header: 'generateReport.dataToResult.report.test.ctod.temperatura_cp1' },
  { header: 'generateReport.dataToResult.report.test.ctod.temperatura_cp2' },
  { header: 'generateReport.dataToResult.report.test.ctod.temperatura_cp3' },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.razao_forca_pre_trinca_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.razao_forca_pre_trinca_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.razao_forca_pre_trinca_cp3',
  },

  { header: 'generateReport.dataToResult.report.test.ctod.valor_ctod_cp1' },
  { header: 'generateReport.dataToResult.report.test.ctod.valor_ctod_cp2' },
  { header: 'generateReport.dataToResult.report.test.ctod.valor_ctod_cp3' },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.pre_trinca_minima_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.pre_trinca_minima_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.pre_trinca_minima_cp3',
  },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.profundidade_entalhe_min_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.profundidade_entalhe_max_cp1',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.profundidade_entalhe_min_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.profundidade_entalhe_max_cp2',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.profundidade_entalhe_min_cp3',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.profundidade_entalhe_max_cp3',
  },

  {
    header: 'generateReport.dataToResult.report.test.ctod.largura_entalhe_cp1',
  },
  {
    header: 'generateReport.dataToResult.report.test.ctod.largura_entalhe_cp2',
  },
  {
    header: 'generateReport.dataToResult.report.test.ctod.largura_entalhe_cp3',
  },

  { header: 'generateReport.dataToResult.report.test.ctod.media_ctod_3cps' },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp1_a',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp1_b',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp2_a',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp2_b',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp3_a',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.angulo_pre_trinca_cp3_b',
  },

  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_fratura_cp1_a',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_fratura_cp1_b',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_fratura_cp2_a',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_fratura_cp2_b',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_fratura_cp3_a',
  },
  {
    header:
      'generateReport.dataToResult.report.test.ctod.comprimento_fratura_cp3_b',
  },
]
